import React, { useState, useEffect } from 'react';

const content = [
  { text: 'Customer Obsessed.', animation: 'fade' },
  { text: 'Owners at Heart.', animation: 'fade' },
  { text: 'Curious and Ever Changing.', animation: 'fade' },
  { text: 'Here to Win.', animation: 'fade' },
  { text: 'We Extend Ourselves.', animation: 'fade' },
  { text: '1-Way vs 2-Way Door Decisions.', animation: 'fade' },
  { text: 'Systems Thinking.', animation: 'fade' },
  { text: 'Have Backbone; Disagree and Commit.', animation: 'fade' },
  { text: 'Deliver Results.', animation: 'fade' },
];

const LeadershipPrinciples = () => {
  const [index, setIndex] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false); // Start fade out
      setTimeout(() => {
        setIndex((prevIndex) => (prevIndex + 1) % content.length);
        setFade(true); // Start fade in
      }, 500); // Wait for fade out
    }, 4000); // Rotate every 4 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <div style={{ textAlign: 'center', margin: '40px 0', minHeight: '120px', padding: '0 20px' }}>
      <h4 style={{ color: 'var(--accent-color)', marginBottom: '20px' }}>Here are my leadership principles:</h4>
      <h2
        style={{
          color: 'var(--text-main)',
          transition: 'opacity 0.5s ease-in-out',
          opacity: fade ? 1 : 0
        }}
      >
        {content[index].text}
      </h2>
    </div>
  );
};

export default LeadershipPrinciples;
